<template>
  <div>
    <div class="wrapper">
      <div class="ccui-clearfix pt10" style="position: relative">
        <!--类别-->
        <catalog></catalog>
        <!--轮播图-->
        <slideShow :imgData="imgOptionsA"></slideShow>
        <!--用户登录信息-->
        <showUser :imgData="imgOptionsB"></showUser>
      </div>
    </div>
    <!--公告列表-->
    <notice-item></notice-item>
    <!-- <notice-item2></notice-item2> -->
    <div class="wrapper">
      <div class="ccui-clearfix pt10" style="position: relative">
        <notice-list></notice-list>
      </div>
    </div>
  </div>
</template>

<script>
import catalog from "@/app/shop/components/catalog.vue";
import slideShow from "@/app/shop/components/slideShow.vue";
import showUser from "@/app/shop/components/showUser.vue";
import noticeList from "@/app/shop/components/noticeList.vue";
import noticeItem from "@/app/shop/components/noticeItem.vue";
// import noticeItem2 from "@/app/shop/components/noticeItem2.vue";
// import Cookies from "js-cookie";
import { qryPostersList } from "@/app/shop/api/shopping";
// import { checkDjgMainStayinfo } from "@/app/shop/api/shopping";
export default {
  name: "shopping",
  components: {
    catalog,
    slideShow,
    showUser,
    noticeList,
    noticeItem
    // noticeItem2
  },
  data() {
    return {
      baseUrl: this.$addUrlPerFix(process.env.VUE_APP_BASE_URL),
      imgOptionsA: [],
      imgOptionsB: [],
      imgOptionsC: []
    };
  },
  activated() {
    // 董监高信息补充隐藏
    // if (Cookies.get("access_token")) {
    //   // 供应商校验
    //   checkDjgMainStayinfo({
    //     supinfoId: JSON.parse(localStorage.getItem("supInfo")).supinfoId
    //     // supinfoId: "111111"
    //   }).then(res => {
    //     if (res.data.code == "0") {
    //       // let address = "";
    //       // address =
    //       //   res.data.data.address.split("?")[0] +
    //       //   "?key=infoChangeRelationInfo&" +
    //       //   res.data.data.address.split("?")[1];
    //       if (res.data.message) {
    //         this.$confirm(
    //           res.data.message + "！",
    //           this.$t("page.retrievePassword.confirmHint"),
    //           {
    //             confirmButtonText: this.$t("page.content.sure"),
    //             showCancelButton: false,
    //             showClose: false,
    //             closeOnClickModal: false,
    //             type: "warning"
    //           }
    //         ).then(() => {
    //           if (this.baseUrl.indexOf("dev01") != -1) {
    //             window.location.href =
    //               "https://dev01-crma.iccec.cn" + res.data.data.address;
    //           } else if (this.baseUrl.indexOf("test01") != -1) {
    //             window.location.href =
    //               "https://test01-crma.iccec.cn" + res.data.data.address;
    //           } else if (this.baseUrl.indexOf("uat01") != -1) {
    //             window.location.href =
    //               "https://uat01-crma.iccec.cn" + res.data.data.address;
    //           } else {
    //             window.location.href =
    //               "https://crma.iccec.cn" + res.data.data.address;
    //           }
    //         });
    //       }
    //     }
    //   });
    // }

    this.init();
  },
  deactivated() {},
  methods: {
    init() {
      // 查询宣传海报
      qryPostersList({
        moudle: 1,
        pageState: 2,
        appId: 100123
      }).then(res => {
        if (res.data.code === "0") {
          this.imgOptionsA =
            res.data.data.qryPostersListRspListBO[0].publicityContentBOS;
          this.imgOptionsB =
            res.data.data.qryPostersListRspListBO[1].publicityContentBOS;
          // this.imgOptionsB = [];
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.pt10 {
  padding-top: 10px;
}
</style>
